export function formatAmount(amount, { withCents = false } = {}) {
  const fractionDigits = withCents ? 2 : 0;

  return `${Number(amount).toLocaleString("en-AU", {
    style: "currency",
    currency: "AUD",
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })}`;
}
